import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { ApiEndpoint } from '../types/api';
import { IdName } from '../types/app';
import { postRequest } from './api';
import { URLS } from './urls/urls';

export const getDeviceModelsSearch = async (
  page?: number,
  search?: string,
  include?: string[],
  exclude?: string[]
): Promise<{ error?: ApiError; deviceModelsPaginated: PaginatedResponse<IdName> }> => {
  const body = {
    page: page ?? 1,
    search,
    include: include ?? [],
    exclude: exclude ?? [],
  };
  const response = await postRequest(
    URLS.deviceModels.search,
    {
      body,
    },
    ApiEndpoint.core
  );
  return {
    deviceModelsPaginated: response?.data,
    error: response?.error,
  };
};
